import DeviceDetector from "device-detector-js";

const deviceDetector = new DeviceDetector();
const osDetected = deviceDetector.parse(window.navigator.userAgent);

if (osDetected) {
  if (osDetected.os.name === 'iOS') {
    window.location.replace('kontron-atl://default');
    setTimeout(() => {
      window.location.replace('https://apps.apple.com/ru/app/breeze-mobile-2/id1671615377');
    }, 5000);
  }

  if (osDetected.os.name === 'Android') {
    window.location.replace('intent://path#Intent;scheme=kontron-atl://default;package=com.kontron.breeze;end');
  }
}
